import customerImage from "../assets/customerr.webp";
import handImage from "../assets/our_advantages/customerr.jpg";
import laptopGirlImage from "../assets/our_advantages/girl-laptop.png";
import sixPlusImage from "../assets/6plus.png";
import creativityImage from "../assets/our_advantages/creativity.png";
import underline from "../assets/underlinea.png";
import w from "../assets/our_advantages/W.jpg";
import bg from "../assets/our_advantages/BG.png";
import { Helmet } from "react-helmet-async";
import sparkLeft from "../assets/spark-green.svg";
import sparkRight from "../assets/spark-yellow.svg";
import creativityIcon from "../assets/creativity-icon.svg";
import processIcon from "../assets/process-iconn.svg";

const cards = [
  {
    title: "Skills",
    desc: "“Our technical team represents more than 10+ years of software development experience. We are a very mixed group with expertise ranging from driver integration developments to Enterprise development.“",
  },
  {
    title: "Passion",
    desc: "“We just love software development – it's as simple as that. That love brings in the passion to create something amazing. . And the passion gives us the energy that drives us.“",
  },
  {
    title: "Process",
    desc: "“We are great believers of the Agile methodology in software development. Everything is bound to change and we are prepared for that change. We love to develop in small steps – giving our customers something to look at and give us feedback in at every stage.“",
  },
  {
    title: "Culture",
    desc: "“We are not just a place where software gets made. We see our space as a place for solving problems, for fun and creativity, for crafting things that are as simple to use as they are beautiful to look at. Our culture is open and without hierarchy.“",
  },
];

export default function LenteraStory() {
  const stats = [
    {
      value: "98%",
      title: "Quality of support",
      description:
        "You don’t have a great business if you don’t have great customer support.",
    },
    {
      value: "100%",
      title: "Ease of doing business",
      description:
        "We pride ourselves on being a trusted partner to all of our customers.",
    },
    {
      value: "95%",
      title: "Ease of use",
      description:
        "Data management and governance shouldn’t be so painful. We make it easy.",
    },
  ];

  return (
    <>
      <Helmet>
        <title>Innovative Tech Solutions | Company Journey & Milestones</title>
        <meta
          name="description"
          content="With 35+ skilled employees, 15+ products and a commitment to innovation, integrity and impact, we deliver solutions that simplify workflows and drive business efficiency."
        />
        <meta
          name="keywords"
          content="Lentera company story, tech solutions company, business software innovation, B2B SaaS platform, global tech company."
        />
      </Helmet>

      <section className="relative w-full bg-white font-poppins px-4 sm:px-6 lg:px-8 py-16 overflow-hidden">
        <div className="relative max-w-screen-xl mx-auto h-auto">
          {/* Text Block */}
          <div className="absolute inset-x-0 top-0 z-20 text-center mt-[-4rem] sm:mt-[-5rem] md:mt-[-6rem]">
            <p className="text-green-600 font-medium text-base">
              Our journey started with newbies
            </p>
            <img
              src={underline}
              alt="underline"
              className="mx-auto mt-2 w-36 h-3"
            />
            <h2 className="text-4xl sm:text-5xl font-semibold mt-4 text-gray-900">
              The Lentera Story
            </h2>
            <p className="mt-4 text-gray-500 text-base sm:text-lg max-w-2xl mx-auto px-2">
              We value strong client partnerships—and it shows. No one delivers
              innovative IT solutions quite like our team.
            </p>
          </div>

          {/* Desktop Grid */}
          <div className="hidden lg:grid grid-cols-5 gap-x-4 gap-y-6 mt-16">
            {/* Card 1 */}
            <div className="bg-[#DDF5E6] rounded-2xl p-4 flex flex-col justify-between items-center text-center h-[22rem]">
              <p className="text-lg font-medium">
                100+
                <br />
                Delighted customers
              </p>
              <img
                src={customerImage}
                alt="Customer"
                className="top-20 w-4/4 h-auto object-contain"
              />
            </div>

            {/* Card 2 (staggered down 16%) */}
            <div className="bg-[#F5F5F5] relative top-[60%] rounded-2xl p-4 flex flex-col justify-between items-center text-center h-[21rem]">
              <p className="text-lg font-medium">
                Professional minds,
                <br />
                simplified software
              </p>
              <img
                src={laptopGirlImage}
                alt="Laptop Girl"
                className="top-20 w-4/4  h-auto object-contain"
              />
            </div>

            {/* Card 3 (staggered down more) */}
            <div className="bg-[#FFE7F1] relative top-[90%] rounded-2xl p-4 flex flex-col justify-between items-center text-center h-[15rem]">
              <p className="text-lg font-medium">
                Delivering innovation
                <br />
                6+ years
              </p>
              <img
                src={sixPlusImage}
                alt="6+ Years"
                className="top-20 w-4/4  h-auto object-contain"
              />
            </div>

            {/* Card 4 (same as card 2) */}
            <div className="bg-[#FFF1E1] relative top-[60%] rounded-2xl p-4 flex flex-col justify-between items-center text-center h-[21rem]">
              <p className="text-lg font-medium">
                Driven by a culture
                <br />
                of creativity
              </p>
              <img
                src={creativityImage}
                alt="Creativity"
                className="top-0 w-full h-auto object-contain"
              />
            </div>

            {/* Card 5 */}
            <div className="bg-[#E5D9FB] rounded-2xl p-4 flex flex-col justify-between items-center text-center h-[22rem]">
              <p className="text-lg font-medium">
                Passion-driven,
                <br />
                united by code
              </p>
              <img
                src={handImage}
                alt="Hands"
                className="top-20 w-full h-auto object-contain"
              />
            </div>

            {/* Small Card 6 */}
            <div className="relative flex flex-wrap justify-center gap-6">
              {/* Left Card */}
              <div className="bg-[#FFE1E1] w-64 h-40 rounded-2xl p-4 flex flex-col justify-center items-center text-center shadow-md">
                <h3 className="text-2xl font-semibold">100%</h3>
                <p className="text-base text-center">
                  On time delivery accuracy
                  <br />
                  in all worked projects
                </p>
              </div>
            </div>

            {/* Small Card 7 (staggered right bottom) */}
            <div className="bg-[#D7EEFF]  w-64 h-40 absolute right-[-20px] bottom-4 rounded-2xl p-4 flex flex-col justify-center items-center text-center">
              <h3 className="text-2xl font-semibold">24/7</h3>
              <p className="text-base">
                Providing valuable customer
                <br />
                support service
              </p>
            </div>
          </div>

          {/* Mobile Layout */}
          <div className="lg:hidden mt-12 space-y-8">
            {[
              customerImage,
              laptopGirlImage,
              sixPlusImage,
              creativityImage,
              handImage,
            ].map((img, idx) => (
              <div
                key={idx}
                className={`bg-white rounded-2xl p-4 flex flex-col justify-between items-center text-center h-auto ${
                  idx >= 1 && "mt-10"
                }`}
              >
                {/* Use proper conditional content */}
                <img src={img} alt="" className="w-3/4 h-auto object-contain" />
              </div>
            ))}
            {/* Small Cards below */}
            <div className="flex flex-wrap justify-center gap-6">
              <div className="bg-[#FFE1E1] w-64 h-42 rounded-2xl p-4 flex flex-col justify-center items-center text-center shadow-md">
                <h3 className="text-2xl font-semibold">100%</h3>
                <p className="text-base text-center">
                  On time delivery accuracy
                  <br />
                  in all worked projects
                </p>
              </div>

              <div className="bg-[#D7EEFF] w-64 h-40 rounded-2xl p-4 flex flex-col justify-center items-center text-center shadow-md">
                <h3 className="text-2xl font-semibold">24/7</h3>
                <p className="text-base mt-2 leading-snug text-center">
                  Providing valuable customer
                  <br />
                  support service
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="w-full bg-white px-4 md:px-8 py-16 text-center font-poppins">
        <div className="max-w-5xl mx-auto">
          {/* Title */}
          <h2 className="text-[36px] md:text-[48px] font-bold text-[#1A1A1A] leading-tight">
            Principles we strongly <br className="hidden md:block" />
            believe in
          </h2>
          <p className="mt-4 text-[#4B4B4B] text-[16px] md:text-[18px] leading-[30px]">
            These core values guide our decisions, shape our culture and drive
            everything we do.
          </p>

          {/* Cards Grid */}
          <div className="mt-20 grid grid-cols-1 md:grid-cols-2 gap-y-16 gap-x-12 text-left">
            {/* Card 1 */}
            <div className="flex flex-col items-start text-left">
              <img
                src={creativityIcon}
                alt="Creativity"
                className="w-16 h-16 mb-6"
              />
              <h3 className="text-[22px] font-semibold text-[#1A1A1A] mb-2 leading-snug">
                Culture of creativity
              </h3>
              <p className="text-[16px] text-[#4B4B4B] leading-[28px] font-normal">
                Great software needs more than skill—it needs a creative
                culture. We empower independent teams and design spaces that
                inspire focus and innovation.
              </p>
            </div>

            {/* Card 2 with left border */}
            <div className="flex flex-col items-start text-left border-l border-[#E5E5E5] pl-6 md:pl-8">
              <img
                src={processIcon}
                alt="Process Flow"
                className="w-16 h-16 mb-6"
              />
              <h3 className="text-[22px] font-semibold text-[#1A1A1A] mb-2 leading-snug">
                Geared process flow
              </h3>
              <p className="text-[16px] text-[#4B4B4B] leading-[28px] font-normal">
                We believe in full transparency. Customers see daily progress,
                with access to everything from builds to task boards—enabling
                constant feedback and quick adjustments.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="w-full font-poppins bg-white relative overflow-hidden">
        {/* Green Card Section */}
        <div className="bg-[#27ec88] pt-20 pb-36 rounded-b-[60px] relative z-10">
          {/* Heading */}
          <div className="text-center px-4 max-w-[960px] mx-auto mb-12">
            <h2 className="text-[32px] sm:text-[38px] font-bold text-[#141414] leading-tight">
              Four ingredients you need <br /> for amazing software
            </h2>
            <p className="text-[#1f1f1f] text-[16px] sm:text-[17px] mt-3">
              Skill, passion, process and culture—four essentials for amazing
              software.
            </p>
          </div>

          {/* Card Grid */}
          <div className="max-w-[1320px] mx-auto px-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {cards.map((card, index) => (
              <div
                key={index}
                className="bg-white rounded-[20px] h-[390px] p-6 shadow-[0px_15px_25px_-8px_rgba(0,0,0,0.08)] flex flex-col"
              >
                <h3 className="text-[18px] font-semibold italic text-black leading-tight">
                  {card.title}
                </h3>
                <img
                  src={underline}
                  alt="underline"
                  className="w-[70px] mt-1"
                />
                <p className="text-[#2e2e2e] text-[15px] mt-4 leading-relaxed">
                  {card.desc}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Black Brands Section - Pull Up Inside Green */}
        <div className="w-full bg-[#232323] text-white relative z-20 -mt-24 pt-20 pb-14">
          <div className="max-w-[980px] mx-auto px-4 text-center relative">
            {/* Spark icons */}
            <img
              src={sparkLeft}
              alt="spark-left"
              className="absolute left-0 top-0 w-[48px]"
            />
            <img
              src={sparkRight}
              alt="spark-right"
              className="absolute right-0 top-0 w-[48px]"
            />

            {/* Title */}
            <h2 className="text-white font-bold text-[24px] sm:text-[28px] mb-4">
              OUR BRANDS
            </h2>

            {/* Description */}
            <p className="text-[15px] sm:text-[16px] leading-relaxed">
              Our Lentera site proudly features products like Mawalog and
              Ticketzee, each specializing in unique, high-impact solutions.
              Mawalog excels in advanced gate control systems, while Ticketzee
              offers streamlined ticketing services.
            </p>
          </div>
        </div>
      </section>

      <section className="flex flex-col md:flex-row items-center justify-between gap-10 px-6 md:px-20 py-20 max-w-7xl mx-auto font-[Poppins]">
        {/* Left Side: Just the Image */}
        <div className="w-full md:w-1/2 flex justify-center">
          <img
            src={w} // Replace with your actual image path or variable
            alt="Team Member"
            className="w-[430px] md:w-[500px] rounded-xl object-contain"
          />
        </div>

        {/* Right Side: Content */}
        <div className="w-full md:w-1/2">
          <div className="inline-block bg-[#D1FAE5] text-green-700 text-xs font-semibold px-3 py-1 rounded-full mb-4">
            Out strength
          </div>
          <h2 className="text-2xl md:text-3xl font-extrabold text-gray-900 leading-tight mb-4">
            Strong technical skills are
            <br className="hidden md:block" /> our biggest asset
          </h2>
          <p className="text-sm md:text-base text-gray-700 leading-relaxed">
            We have wide experience both in development platforms and business
            domains. Over the years we have worked on projects ranging from
            trivial to immensely challenging and in the process have gained
            in-depth knowledge about different technology platforms. We hire
            only the best in the market and we have regular internal and
            external training sessions to keep us at the top of our profession.
          </p>
        </div>
      </section>
      <section
        className="py-20 px-4 text-white font-poppins bg-cover bg-center"
        style={{ backgroundImage: `url(${bg})` }}
      >
        <div className="max-w-6xl mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl font-semibold mb-2">
            Customer Love
          </h2>
          <div className="w-24 h-[2px] bg-white mx-auto mb-12"></div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 text-center items-start">
            {stats.map((stat, idx) => (
              <div key={idx} className="relative px-4 md:px-6">
                <div className="text-4xl font-semibold mb-2">{stat.value}</div>
                <h3 className="text-lg font-semibold mb-2">{stat.title}</h3>
                <p className="text-sm sm:text-base text-white">
                  {stat.description}
                </p>

                {/* Vertical Divider for middle items on desktop */}
                {idx < stats.length - 1 && (
                  <div className="hidden md:block absolute top-2 left-full h-full w-px bg-white opacity-30"></div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
